<template>
  <div>

    <div class="bg-gray-lightest min-h-[500px] flex flex-col pb-[80px]">
        <router-view v-if="isLoaded" :key="route.params[route.meta.watchParam]" />
    </div>

    <div class="flex justify-center w-full bg-white">
        <footer class="bg-white" style="width: 1020px;">
            <div class="flex justify-between items-center my-8 text-gray-dark" style="font-family: ArcherLight, Times, serif;">
                <p class="m-0">
                    © {{ currentYear }} Freshability. {{ t('site.all_rights_reserved') }}.
                </p>
                <nav class="flex gap-6">
                    <a href="/privacy-policy" target="_blank" class="text-gray-dark underline">{{ t('site.privacy_policy') }}</a>
                    <a href="/terms-of-service" target="_blank" class="text-gray-dark underline">{{ t('site.terms_of_service') }}</a>
                    <a href="/disclaimer" target="_blank" class="text-gray-dark underline">{{ t('site.disclaimer') }}</a>
                </nav>
            </div>
        </footer>
    </div>

  </div>
</template>
<script setup>
import {useI18n} from 'vue-i18n';
import { ref, provide } from 'vue'
import {useRoute} from 'vue-router'
import {useAppStore} from '@/stores/appStore'
import {useUserStore} from '@/stores/userStore'
import {useNavStore} from '@/stores/navStore'
import req from '@http'

const { t } = useI18n({ useScope: 'global' })

const currentYear = new Date().getFullYear()
const route = useRoute()
const appStore = useAppStore()
const userStore = useUserStore()
const navStore = useNavStore()
const isLoaded = ref(false)

const kurl = (str) => {
  return (window.kohana_url || '') + str
}

provide('appStore', appStore)
provide('userStore', userStore)
provide('navStore', navStore)
provide('t', t)

const init = async() => {
  const rs = await req.get('/api/auth/user')

  const permit = cpyObj(rs?.data?.permit || {})
  delete rs.data.permit
  userStore.$patch({
    permits: permit,
    settings: rs.data
  })

  isLoaded.value = true
}

init()
</script>
